import { TableDefinitionEditorStore } from '@/tableDefinitionEditor/tableDefinitionEditor.store';

export class ItemTableEditorStore extends TableDefinitionEditorStore {
  static readonly storeName = 'sqItemTableEditorStore';
  override handlers = {
    ITEM_SET_TABLE_ID: this.setTableId,
    ITEM_RESET_TABLE_EDITOR_STORE: this.reset,
    ITEM_SET_SHOW_CONFIGURE_SEARCH: this.setShowConfigureSearch,
    ITEM_SET_ENABLE_TREE_CREATION: this.setEnableTreeCreation,
    ITEM_SET_COLUMN_TO_EDIT: this.setColumnToEdit,
    ITEM_SET_SHOW_COLUMN_PROPERTIES: this.setShowColumnProperties,
    ITEM_SET_SELECTED_COLUMN_OPTION: this.setSelectedColumnOption,
    ITEM_SET_SHOW_SIDE_PANE: this.setShowSidePane,
    ITEM_SET_SHORTCUT_SOURCE_COLUMN: this.setShortcutSourceColumn,
  };
}
